import useGlobalEvent from './useGlobalEvent';

/**
 * Returns a function that accepts a callback to be performed when the window resize.
 */
const usePageVisibility = (handler) =>
  useGlobalEvent('visibilitychange', null, handler);

export default usePageVisibility;
